/* this file is transformed by vux-loader */
/* eslint-disable */
import $$ from '@/store/plugins/storage';
import { getSessionUser } from '@/api';

var uuidv1 = require('uuid/v1');

var namespace = 'appStore';
$$.setNamespace(namespace);
var state = {
  sessionID: $$.get('sessionID') || '',
  isReadPrivacy: $$.get('isReadPrivacy') || '',
  problem: '',
  problemList: []
};
var mutations = {
  _isReadPrivacy: function _isReadPrivacy(state, value) {
    state.isReadPrivacy = value;
  },
  _sessionID: function _sessionID(state, value) {
    state.sessionID = value;
  },
  _getProblem: function _getProblem(state, value) {
    state.problem = value;
  },
  getProblemList: function getProblemList(state, value) {
    console.log(value);
    state.problemList = value;
  }
};
var actions = {
  clearData: function clearData(_ref) {
    var commit = _ref.commit;
    commit('globalStore/_user', {}, {
      root: true
    });
    commit('globalStore/_resetKeepAliveList', [], {
      root: true
    });
    commit('_sessionID', uuidv1());
  },
  checkUser: function checkUser(_ref2) {
    var commit = _ref2.commit;
    getSessionUser().then(function (res) {
      commit('globalStore/_user', res.data, {
        root: true
      });
    });
  }
};
var getters = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};